import { queryKeys as appConfigKeys } from '~/App/Api/AppConfig';
import { useQueryClient } from 'react-query';

export const onSyncBillingSuccessEventName = 'sync-billing::success';

export default function useSyncBilling() {
  const queryClient = useQueryClient();
  const syncBilling = async () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const updatedConfig = await (await fetch('/api/v3/billing/sync')).json();
    await queryClient.setQueryData(appConfigKeys.detail, updatedConfig);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    window.Bonjoro = updatedConfig;

    window.dispatchEvent(new CustomEvent(onSyncBillingSuccessEventName));
    return updatedConfig;
  };

  return {
    syncBilling,
  };
}
